import React from "react"
import { money, pct } from "./format"

// Sits at the end of the growth strip: ARPU and take rate side by side, with a
// revenue-concentration footnote.
export function EfficiencyCard({ efficiency, copy }) {
  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{money(efficiency.arpu_cents, efficiency.currency)}</p>
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400">{copy.arpu}</p>
          <p className="text-xs text-gray-400 dark:text-gray-500">{copy.arpuUnit}</p>
        </div>
        <div>
          <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{pct(efficiency.take_rate_pct)}</p>
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400">{copy.takeRate}</p>
          <p className="text-xs text-gray-400 dark:text-gray-500">{copy.takeRateUnit}</p>
        </div>
      </div>
      <div className="mt-4 border-t border-gray-100 dark:border-gray-800 pt-3">
        <p className="text-xs font-medium text-gray-500 dark:text-gray-400">{copy.concentration}</p>
        <p className="text-sm font-semibold text-gray-700 dark:text-gray-300">
          {copy.concentrationBody.replace("{pct}", efficiency.concentration_top5_pct)}
        </p>
      </div>
    </div>
  )
}
